import { Request } from '@/lib/http';
import store from '@/store';
import AuthEnum from '../lib/enums/auth-enum';

const baseUrl = '/api/files-api';

export default {
  getFileList(filePath) {
    let request;
    if (store.getters.configAuth === 'authv2') {
      const tenantId = store.getters.tenant.id;
      request = new Request(`${baseUrl}/${tenantId}/list?path=${filePath}`, {
        authType: AuthEnum.TENANT,
      });
    } else {
      request = new Request(`${baseUrl}/list?path=${filePath}`, {
        authType: AuthEnum.FIREBASE,
      });
    }
    return request.send();
  },
  getFileDownload(filePath) {
    let request;
    if (store.getters.configAuth === 'authv2') {
      const tenantId = store.getters.tenant.id;
      request = new Request(`${baseUrl}/${tenantId}/download?path=${filePath}`, {
        authType: AuthEnum.TENANT,
        raw: true,
      });
    } else {
      request = new Request(`${baseUrl}/download?path=${filePath}`, {
        authType: AuthEnum.FIREBASE,
        raw: true,
      });
    }
    return request.send();
  },
};
